import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from 'react-hot-toast'
import ProtectedRoute from './components/auth/ProtectedRoute'

// Auth Pages
import LoginPage from './pages/auth/LoginPage'
import CompanySignup from './pages/auth/CompanySignup'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'

// Company Pages
import CompanyDashboard from './pages/company/CompanyDashboard'
import CompanyProfileView from './pages/company/CompanyProfileView'
import CompanyOnboarding from './pages/company/CompanyOnboarding'
import JobPosting from './pages/company/JobPosting'
import TalentSearch from './pages/company/TalentSearch'
import TalentRequest from './pages/company/TalentRequest'
import CompanyShortlists from './pages/company/CompanyShortlists'
import CompanyInterviews from './pages/company/CompanyInterviews'
import CompanyAnalytics from './pages/company/CompanyAnalytics'
import CompanyComplianceAlerts from './pages/company/CompanyComplianceAlerts'
import CompanyReports from './pages/company/CompanyReports'
import CompanyRegistration from './pages/company/CompanyRegistration'
import CompanySettings from './pages/company/CompanySettings'
import CompanyProfileBuilding from './pages/company/steps/CompanyProfileBuilding'
import LegalEntityDetailsPage from './pages/company/LegalEntityDetailsPage'
import ProfileBuildingPage from './pages/company/ProfileBuildingPage'
import SubscriptionPlanPage from './pages/company/SubscriptionPlanPage'
import DocumentUploadPage from './pages/company/DocumentUploadPage'

import DashboardLayout from './components/common/DashboardLayout'

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-200">
        <Routes>
          {/* Public Authentication Routes */}
          <Route path="/" element={<Navigate to="/auth/login" replace />} />
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/signup/company" element={<CompanySignup />} />

          <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />

          {/* Company Routes - Typically Protected */}
          {/* Note: In a real app, these should be wrapped in a ProtectedRoute component */}

          {/* Signup Flow */}
          {/* Signup Flow */}
          <Route path="/company/setup" element={<CompanyOnboarding />} />
          <Route path="/company/registration" element={<Navigate to="/company/registration/legal-details" replace />} />
          <Route path="/company/registration/legal-details" element={<LegalEntityDetailsPage />} />
          <Route path="/company/registration/profile" element={<ProfileBuildingPage />} />
          <Route path="/company/registration/subscription" element={<SubscriptionPlanPage />} />
          <Route path="/company/registration/documents" element={<DocumentUploadPage />} />
          <Route path="/company/document-upload" element={<Navigate to="/company/registration/documents" replace />} />

          {/* Dashboard & Features - wrapped in ProtectedRoute + DashboardLayout */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* Redirect /dashboard -> /dashboard/company by default */}
            <Route index element={<Navigate to="company" replace />} />
            <Route path="company" element={<CompanyDashboard />} />
            <Route path="company/profile" element={<CompanyProfileView />} />
            <Route path="company/profileBuilding" element={<CompanyProfileBuilding />} />
            <Route path="company/jobs" element={<JobPosting />} />
            <Route path="company/talent" element={<TalentSearch />} />
            <Route path="company/talent/request" element={<TalentRequest />} />
            <Route path="company/shortlists" element={<CompanyShortlists />} />
            <Route path="company/interviews" element={<CompanyInterviews />} />
            <Route path="company/analytics" element={<CompanyAnalytics />} />
            <Route path="company/compliance" element={<CompanyComplianceAlerts />} />
            <Route path="company/reports" element={<CompanyReports />} />
            <Route path="company/settings" element={<CompanySettings />} />
          </Route>
        </Routes>

        <Toaster
          position="top-right"
          containerStyle={{
            zIndex: 9999,
          }}
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#fff',
              borderRadius: '8px',
              padding: '12px 16px',
              zIndex: 9999,
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
          gutter={8}
        />
      </div>
    </AuthProvider>
  )
}

export default App
